import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { buildListingParams } from './listing.params'

/**
 * Configuration. Read and update only — there is no create and no delete,
 * because a key only means something if some PHP reads it. New keys arrive
 * through the backend's ConfigurationSeeder.
 */
export const configurationService = {
  getAllConfigurations,
  getConfiguration,
  updateConfiguration,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  return buildListingParams(filter, {
    key: filter?.key,
    // Multi-select: "show me every boolean switch" is how people navigate this
    // screen once there are more than a dozen keys.
    value_type: filter?.valueTypes,
  })
}

export async function getAllConfigurations(filter) {
  return apiHelper(API_URL).get('/configurations', { params: buildParams(filter) })
}

export async function getConfiguration(key) {
  return apiHelper(API_URL).get(`/configurations/${encodeURIComponent(key)}`)
}

export async function updateConfiguration(key, value) {
  return apiHelper(API_URL).put(`/configurations/${encodeURIComponent(key)}`, { value })
}
